/* Hidra Plus LP — libera os assets pesados do Rapi perto do caminho de compra. */
(function () {
  'use strict';

  var released = false;
  var ctaNavigationPending = false;
  var ctaReleaseTimer = null;

  function release() {
    if (released) return;
    released = true;
    document.documentElement.setAttribute('data-hp-rapi-release', 'released');
    window.__hpRapiAssetsReady = true;

    if (window.__hpRapiGate && typeof window.__hpRapiGate.release === 'function') {
      window.__hpRapiGate.release();
    }

    var pending = window.__hpRapiPending;
    window.__hpRapiPending = null;
    if (typeof pending === 'function') pending();
  }

  function isBuyIntent(target) {
    return target && target.closest && target.closest(
      'a[href="#buy-box"], a[href="#oferta"], a[href^="#ProductInfo-"], #cart-icon-bubble, cart-drawer, form[action*="/cart/add"], product-form, [name="add"]'
    );
  }

  function isBuyBoxCta(target) {
    return target && target.closest && target.closest(
      'a[href="#buy-box"], a[href="#oferta"], a[href^="#ProductInfo-"]'
    );
  }

  function releaseAfterCtaScroll() {
    if (ctaNavigationPending || released) return;
    ctaNavigationPending = true;
    document.documentElement.setAttribute('data-hp-rapi-release', 'cta-wait');

    function finish() {
      if (!ctaNavigationPending) return;
      ctaNavigationPending = false;
      clearTimeout(ctaReleaseTimer);
      release();
    }

    ctaReleaseTimer = window.setTimeout(finish, 1200);
  }

  function releaseFromIntent(event) {
    if (isBuyBoxCta(event.target)) {
      releaseAfterCtaScroll();
      return;
    }
    if (isBuyIntent(event.target)) {
      document.documentElement.setAttribute('data-hp-rapi-release', 'intent-' + event.type);
      release();
    }
  }

  function observeBuyBox() {
    var buyBox = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('#buy-box, #oferta');
    if (!buyBox || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      if (ctaNavigationPending) return;
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      document.documentElement.setAttribute('data-hp-rapi-release', 'proximity');
      release();
    }, { rootMargin: '1400px 0px' });
    observer.observe(buyBox);
  }

  window.__hpRapiAssetsReady = false;
  window.__hpReleaseRapiAssets = release;
  document.addEventListener('pointerdown', releaseFromIntent, { capture: true, passive: true });
  document.addEventListener('focusin', releaseFromIntent, true);
  document.addEventListener('submit', releaseFromIntent, true);
  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#buy-box' || window.location.hash === '#oferta') release();
  });

  if (window.location.hash === '#buy-box' || window.location.hash === '#oferta') release();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBuyBox, { once: true });
  } else {
    observeBuyBox();
  }
})();
